<template>
  <div class="chooseProduct">
    <div class="chooseEntBox">
      <div class="form-group white">
        <label :class="[isDetails ? 'van-col--7' : 'van-col--8']">
          {{isDetails ? '样品名称' : '产品名称'}}：
          <span class="imp">*</span>
        </label>
        <div :class="[isDetails ? 'van-col--14' : 'van-col--16']">
          <input v-model="pageProductName" @click="showProductList" :readonly="customEnt"
            :placeholder="isDetails ? customEnt?'请选择样品名称':'请输入样品名称' : customEnt?'请选择产品名称':'请输入产品名称'" />
        </div>
      </div>
    </div>
    <!-- 选择产品 -->
    <van-popup v-model="showProductPop" position="right" class="pageBox">
      <div class="page">
        <div class="top">
          <div class="header">
            <div class="left" @click="showProductPop=false;"></div>
            <h1>选择{{isDetails ? '样品' : '产品'}}</h1>
          </div>
          <van-search v-model="searchProductName" :placeholder="'请输入' + isDetails ? '样品名称' : '产品名称'" show-action
            shape="round" @search="onProductSearch">
            <div slot="action" class="searchBtn" @click="onProductSearch">搜索</div>
          </van-search>
          <div class="totalNum">总数：{{total}} 个</div>
        </div>
        <div class="list">
          <p class="noDataText" v-if="list.length === 0 && finished">暂无数据</p>
          <van-list v-model="loading" :finished="finished" @load="getPageEnterpriseProduct" :immediate-check="true">
            <p v-for="(item, index) in list" :key="index" class="item" @click="chooseProduct(item)">
              <span class="span1">{{index + 1}}.</span>
              <span class="span2">{{item.productName}}</span>
            </p>
          </van-list>
        </div>
        <div class="addBtn">
          <van-button type="primary" size="small" @click="addPro">添加产品</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { pageEnterpriseProduct } from '@/api/dictionary';

export default {
  name: "chooseProduct",
  // props: ['showEntId', 'showProductId', 'showProductName', 'isDetails','customEnt'],
  props: {
    showEntId: String,
    showProductId: String,
    showProductName: String,
    isDetails: Boolean,
    customEnt: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: [],
      showEnt: false,
      pageProductName: '',
      pageProductId: '',
      pageNum: 1,
      pageSize: 20,
      total: 0,
      finished: false,
      loading: false,
      showProductPop: false,
      searchProductName: '',
    }
  },
  watch: {
    showEntId(newValue) {
      if (!newValue) return
      this.pageProductId = '';
      this.pageProductName = '';
      this.onProductSearch();
    },
    showProductId(newValue) {
      this.pageProductId = newValue;
    },
    showProductName(newValue) {
      this.pageProductName = newValue;
    },
    pageProductName(newValue) {
      if (this.customEnt == false) {
        this.$emit('getProductId', {
          productName: newValue,
          productId: ''
        })
      }
    }
  },
  created() {
    this.pageProductName = this.showProductName;
    this.pageProductId = this.showProductId;
    // 用户类型
    // this.checkUserType();
  },
  mounted() {
  },
  methods: {
    showProductList() { // 打开产品列表
      if (this.customEnt) {
        if (this.$checkUserType()) { // 管理员 和 监管用户
          if (!this.showEntId) {
            this.$toast('请先选择企业！');
            return
          }
        }
        this.showProductPop = true;
      }
    },
    onProductSearch() {  // 搜索产品名称
      this.pageNum = 1;
      this.total = 0;
      this.list = [];
      if (this.finished) {
        this.finished = false;
      } else {
        this.getPageEnterpriseProduct();
      }
    },
    chooseProduct(obj) {  // 选择产品名称
      this.pageProductName = obj.productName;
      this.pageProductId = obj.entProductId;
      this.showProductPop = false;
      this.$emit('getProductId', {
        productName: obj.productName,
        productId: obj.entProductId
      })
    },
    getPageEnterpriseProduct() { // 企业产品列表
      pageEnterpriseProduct({
        entId: this.showEntId,
        productName: this.searchProductName,
        pageNum: this.pageNum++,
        pageSize: this.pageSize
      }).then(res => {
        if (res.state === 'Y') {
          let rows = res.rows;
          this.total = parseInt(res.total);
          if (rows.length === 0) {
            this.noDataText = '暂无数据！';
            this.loading = false;
            this.finished = true;
            if (this.pageNum === 2) {
              this.list = [];
            }
            return
          }
          this.list.push(...res.rows.filter(m => {
            return m.isActive === 1;
          }));
          this.loading = false;
          if ((rows.length < this.pageSize) || (parseInt(res.total) === this.pageSize)) {
            this.finished = true;
          }
        } else {
          this.loading = false;
          this.finished = true;
          this.$alertErr(res.msg);
        }
      }).catch(err => {
        this.loading = false;
        this.finished = true;
        this.$alertErr(err || '网络错误，请稍后再试！');
      })
    },
    getEnt() { // 打开选择产品
      this.showProductPop = true;
    },
    checkUserType() { // 获取用户类型
      if (!this.$checkUserType()) { // 企业端 和 游客
        this.showEnt = false;
      } else { // 管理员 和 监管用户
        this.showEnt = true;
      }
    },
    addPro() { // 添加产品
      this.$router.push('products-detail');
    },
  },
  components: {}
}
</script>

<style lang="stylus" scoped>
.chooseProduct {
  width: 100%;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
